export default __webpack_public_path__ + "static/media/m_engineering_card02_2.352e4509.png";